<template>
    <nav id="menu-top">
        <div class="title-menu">
            <h5 class="page-title" @click="toCurrentRoute">{{ pageTitle }}</h5>
        </div>

        <router-link class="customer-logo" :to="redirectPath('/home')" :style="{ backgroundImage: 'url(' + clientLogo + ')' }"></router-link>

        <div class="left">
            <div class="printer-icon" v-if="printing" @click="openPrintQueue()"></div>

            <div class="user-menu" :class="{ logged: emp_id }">
                <div v-if="emp_id" @click="userConfig()" class="user-login">
                    <div class="user-avatar" v-if="user">
                        <img class="main-img" v-bind:src="avatar" />
                    </div>
                    <div class="user-info">
                        <div v-if="user" class="user-name">{{ user.name }} {{ user.surname }}</div>
                        <div class="location" v-if="locationData">{{ locationData.name }}</div>
                    </div>
                    <div v-if="emp_id" class="user-logout" :class="[{ active: emp_id }, loginUserClass]" @click="userLogout">
                        <svg>
                            <circle ref="svgCountdown" :class="counterClass" r="45%" cx="50%" cy="50%" />
                        </svg>
                        <v-idle class="hidden-idle" @idle="handleCounterIdle" @remind="handleCounterRemind" :events="['mousemove', 'keydown', 'mousedown', 'touchstart']" :reminders="remindTime" :duration="idleTime" />
                    </div>
                </div>
            </div>
        </div>

        <!-- <h5 @click="checkLocalStorage">adelante amigo</h5> -->
    </nav>
</template>

<script>
import Vue from 'vue'
import Vidle from 'v-idle'
Vue.use(Vidle)

export default {
    components: {},
    data() {
        return {
            idleTime: idle_time,
            remindTime: [idle_time, idle_last_time],
            counterClass: {},
            loginUserClass: ''
        }
    },
    computed: {
        avatar() {
            if (!this.user.avatar.includes('/')) {
                return '~@/../img/avatar/' + this.user.avatar
            } else {
                return this.user.avatar
            }
        },
        locationData() {
            return this.$store.getters['loginUser/getLocalLocation']
        },
        emp_id() {
            return this.$store.getters['loginUser/getLocalEmployee']
        },
        date() {
            return this.$store.getters['formatedDate']
        },
        time() {
            return this.$store.getters['formatedTime']
        },
        showAlex() {
            return this.$store.state['alex_is_visible']
        },
        user() {
            var employee = this.$store.getters['employee/getEmployee'](this.emp_id)

            if (employee) {
                return employee
            }
        },
        role() {
            if (this.user) {
                if (this.user.rol) {
                    return this.$store.getters['employee/getRol'](this.user.rol)
                }
            }
        },
        titleLink() {
            if (this.emp_id) {
                return this.$tc('menu_top.change_user', 1)
            } else {
                return this.$tc('menu_top.change_user', 2)
            }
        },

        clientLogo() {
            const location = this.$store.getters['login/getLocation']
            if (typeof location !== 'undefined') {
                return location.avatar
            } else {
                return ''
            }
        },

        pageTitle() {
            return this.$t('page_title.' + this.$route.name)
        },

        home() {
            return this.$store.getters['getHome'] ? this.$store.getters['getHome'] : '/home'
        },
        printing() {
            return this.$store.getters['label/getIsPrinting']
        }
    },
    methods: {
        userConfig() {
            this.$router.push({
                name: 'user'
            })
        },
        openTimeclock() {
            this.$popup.timeclock({
                list: this.$store.getters['employee/getClockEmployees']
            })
        },
        changeUserLogin() {
            var self = this
            var path = this.redirectPath(this.$route.path)
            this.$popup.login({
                list: this.$store.getters['employee/getLoginUsers'](0),
                callAfterAccess: function(data) {
                    self.$router.push(self.$root.redirectPath(path)).catch(err => {
                        if (err.name == 'NavigationDuplicated') {
                            self.$router.go(self.$router.history.current)
                        }
                    })
                }
            })
        },
        userLogout(event) {
            event.preventDefault()
            event.stopPropagation()

            var self = this
            const employee_id = this.$store.getters['loginUser/getLocalEmployee']

            if (employee_id) {
                self.$store
                    .dispatch('loginUser/doLogout', {
                        employee: employee_id
                    })
                    .then(function(response) {
                        self.$router.push(self.$root.redirectPath(self.home)).catch(err => {
                            if (err.name == 'NavigationDuplicated') {
                                self.$router.push('/reset' + self.redirectPath(self.home))
                            }
                        })
                        // self.$router.push(self.$root.redirectPath('/home')).catch(err => {
                        //   if (err.name == 'NavigationDuplicated') {
                        //     self.$router.go(self.$router.history.current)
                        //   }
                        // })
                    })
            }
        },
        redirectPath(firstResult) {
            // console.log('redirect')
            return this.$root.redirectPath(firstResult)
        },

        getLetters(string) {
            return this.$root.getFirstLetters(string)
        },

        toCurrentRoute() {
            let currentPath = this.$route.path
            let aux = this.$route.path.split('/')[1]
            let parentPath = typeof aux !== 'undefined' ? '/' + aux : false

            if (parentPath && parentPath != currentPath) {
                this.$router.push({ path: parentPath })
            }
        },

        checkLocalStorage() {
            let local = localStorage

            // localStorage.removeItem("token");
            // localStorage.removeItem("location");
            // localStorage.removeItem("account");
            // localStorage.removeItem("config");
            // localStorage.removeItem("printer");
            // localStorage.removeItem("menu_items");
            // localStorage.removeItem("employee_id");

            // console.log('local')
            // console.log(local)
            //
            // console.log('localStorage')
            // console.log(localStorage)
        },

        handleCounterIdle() {
            var self = this
            const employee_id = this.$store.getters['loginUser/getLocalEmployee']
            if (employee_id) {
                this.$store
                    .dispatch('loginUser/doLogout', {
                        employee: employee_id
                    })
                    .then(function(response) {
                        // self.$router.push(self.$root.redirectPath('/home')).catch(err => {
                        //     if (err.name == 'NavigationDuplicated') {
                        //         self.$router.go(self.$router.history.current)
                        //     }
                        // })
                    })
            }
        },
        handleCounterRemind(time) {
            let self = this

            if (time == this.remindTime[0]) {
                self.loginUserClass = ''
                self.$refs.svgCountdown.style.animation = 'none'
            } else if (time == self.remindTime[1]) {
                self.loginUserClass = 'attention'
                self.$refs.svgCountdown.style.animation = 'idleCountdown ' + self.remindTime[1] + 's linear 1 forwards'
            }
        },
        openPrintQueue() {
            this.$router.push({ name: 'LabelQueue', params: { queue: 1 } }).catch(err => {})
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#menu-top {
    $width-user-menu: rem(275px);
    $width-customer-menu: rem(140px);
    $width-title-menu: rem(220px);

    $min-width-user-menu: $width-user-menu;
    $min-width-title-menu: $width-title-menu;

    $max-width-title-menu: calc(100% - #{$min-width-user-menu} - #{$width-customer-menu});
    $max-width-customer-menu: calc(100% - #{$min-width-user-menu} - #{$width-customer-menu});
    $max-width-user-menu: $width-user-menu;

    @include display-flex();
    @include align-items(flex-start);
    @include justify-content(space-between);
    position: fixed;
    top: $alex-app-padding;
    right: $alex-app-padding;
    z-index: $z-menu-top;
    height: $menu-top-height;
    width: calc(100% - #{$menu-tools-min} - (#{$alex-app-padding} * 4));
    // transition-duration: 0.4s;

    .title-menu,
    .customer-logo,
    .user-menu {
        height: 100%;
        display: inline-block;
    }

    .title-menu {
        width: $width-title-menu;
        max-width: $max-width-title-menu;
        padding: 0 $alex-app-padding;
        overflow: hidden;

        .page-title {
            $space-adjust: rem(10px);
            @include text-ellipsis();
            @include border-top-radius($default-border-radius);
            @include default-box-shadow();
            @include width-fit-content();
            @include font-size(ml); // TODO 1.6rem (no pilla el punto)
            font-family: $text-sbold;
            color: $main-s50;
            padding: 0 12px;
            margin: 0;
            margin-top: $space-adjust;
            display: inline-block;
            max-width: $width-title-menu - $space-adjust;
            height: calc(100% - #{$space-adjust});
            line-height: $menu-top-height - $space-adjust;
            background-color: $default-bg-color;
        }
    }

    .customer-logo {
        // No reemplazar las propiedades de background
        @include opacity(0.8);
        background-repeat: no-repeat;
        background-size: contain;
        background-position: top center;
        // width: $width-customer-menu;
        // height: $menu-top-tools-height !important;
        max-width: 400px;
        height: calc(100% - 0.375rem);
        width: 100%;
        line-height: initial;
        display: inline-block;
        cursor: auto;
    }

    .left {
        @include display-flex();
        width: calc(#{$width-user-menu} + 50px);
        max-width: calc(#{$width-user-menu} + 50px);
        @include justify-content(flex-end);
        .printer-icon {
            @include display-flex();
            @include background($image: img('print_portrait.svg'), $size: 50px, $position: center center);
            height: 50px;
            width: 50px;
            min-width: 50px;
            margin-right: 0px;
            cursor: pointer;
            margin-top: -3px;

            @keyframes pulse {
                0% {
                    transform: scale(0.95);
                }

                70% {
                    transform: scale(1);
                }

                100% {
                    transform: scale(0.95);
                }
            }
        }

        .user-menu {
            $user-size: $menu-top-tools-height;
            $user-size-padding: rem(6px);
            $user-subsize: $user-size - $user-size-padding;
            @include display-inline-flex();
            @include align-items();
            @include justify-content();
            width: $width-user-menu;
            max-width: $max-width-user-menu;
            margin-top: -3px;

            .user-login {
                @include interaction();
                @include display-inline-flex();
                @include align-items();
                @include justify-content(space-between);
                @include border-radius($default-border-radius);
                @include default-box-shadow($o: 0.3);
                // background-color: $default-content-color;
                background-color: #fff;
                width: calc(100%);
                max-width: calc(100% - 5px);
                height: $user-size;
                text-align: center;
                padding-right: $user-size-padding;

                &:hover {
                    background-color: hover(#fff);
                }

                &.unlogued {
                    width: auto;
                }

                .user-avatar {
                    padding: $user-size-padding / 2;
                    min-width: $user-size;
                    width: $user-size;
                    height: $user-size;

                    .main-img {
                        width: $user-subsize;
                        height: $user-subsize;
                    }
                }

                .user-info {
                    display: flex;
                    flex-direction: column;
                    // width: 100%;
                    width: calc(100% - #{$user-size-padding} - #{$user-subsize} - #{$user-size});
                    padding: 0 $user-size-padding;

                    .user-name,
                    .role {
                        @include text-ellipsis();
                        width: 100%;
                    }
                    .user-name {
                        @include font-size(m);
                        font-family: $text-bold;
                        height: auto;
                        color: $neutro-s90;
                    }
                    .location {
                        @include font-size(s);
                        @include background($size: 10px, $image: img('location_dark.svg'), $position: left center);
                        @include text-ellipsis();
                        padding-left: 12px;
                        font-family: $text-medium;
                        height: 15px;
                        line-height: 15px;
                    }
                }

                .user-logout {
                    @include interaction();
                    @include background($image: img('logout_main_t20.svg'), $size: $user-subsize - rem(5px), $color: $neutro, $position: 2.5px 2px);
                    @include border-radius(50%);
                    min-width: $user-subsize;
                    width: $user-subsize;
                    height: $user-subsize;
                    display: inline-block;
                    position: relative;

                    .hidden-idle {
                        display: none;
                    }

                    &.attention {
                        @include background($image: img('logout2_warning.svg'), $size: 22px, $position: center center);
                    }
                    &:hover {
                        background-color: hover($neutro);
                    }

                    svg {
                        position: absolute;
                        top: 0px;
                        left: 0px;
                        right: 0;
                        min-width: $user-subsize;
                        width: $user-subsize;
                        height: $user-subsize;
                        transform: rotateY(-180deg) rotateZ(-90deg);

                        circle {
                            stroke-dasharray: 110px;
                            stroke-dashoffset: 0px;
                            stroke-linecap: round;
                            stroke-width: 4px;
                            stroke: transparent;
                            fill: none;
                            position: absolute;
                            left: 0px;
                            top: 0px;
                            // height: 34px;
                            // width: 34px;
                        }
                    }
                }
            }
        }
    }
}

.opened-menu #menu-top {
    right: unset;
    left: $menu-tools-max;
}

@keyframes idleCountdown {
    0% {
        stroke: transparent;
        stroke-dashoffset: 0px;
    }
    3% {
        stroke: $progress;
    }
    50% {
        stroke: $progress;
    }
    100% {
        stroke: $error;
        stroke-dashoffset: 113px;
    }
}
</style>
